"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitle = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const fds_1 = require("@tcc/fds");
const styles = __importStar(require("./styles.css"));
const PageTitle = ({ label, testId, icon }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)(['fds', styles.pageTitleContainer]), "data-test-id": testId },
    icon && (react_1.default.createElement("div", { className: (0, classnames_1.default)('fds fds-state-enabled fds-mode-dark fds-strength-soft fds-fill-clean fds-color-accent_fv_orange', styles.pageTitleIconContainer) },
        react_1.default.createElement(fds_1.Icon, { icon: icon, variation: fds_1.IconVariation.Filled, testId: "page-title-icon" }))),
    react_1.default.createElement("div", { className: (0, classnames_1.default)([
            'fds fds-text-body fds-text-heading fds-strength-strong fds-fill-clean',
            styles.pageTitle,
        ]) }, label)));
exports.PageTitle = PageTitle;
